import { render, staticRenderFns } from "./AlunoInstituicao.vue?vue&type=template&id=7693eac5&"
import script from "./AlunoInstituicao.vue?vue&type=script&lang=js&"
export * from "./AlunoInstituicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports